import { useEffect, useSyncExternalStore } from 'react';

// ----------------------------------------------------------------------
// Store leve (sem Context/Provider) para saber se algum painel de filtro
// (drawer) está aberto em qualquer tela. Usado para esconder o widget do
// Intercom enquanto o filtro estiver expandido — o Intercom se injeta fora
// da árvore React com z-index altíssimo e fica por cima do drawer, que não
// tem backdrop (slotProps.backdrop.invisible=true).

let openCount = 0;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return openCount > 0;
}

export function useIsAnyFilterPanelOpen() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

// Chamar em cada componente de painel de filtro, passando o `open` local dele.
export function useRegisterFilterPanelOpen(open: boolean) {
  useEffect(() => {
    if (!open) return undefined;

    openCount += 1;
    notify();

    return () => {
      openCount -= 1;
      notify();
    };
  }, [open]);
}
